import React from "react";
import { Link } from "react-router-dom";
import type { INotificationItem } from "./NotificationsMenu";
import type { RootAbility } from "~/root_ability";
import { dashboardLinks } from "~/modules/Dashboard";
import { paymentsLinks } from "~/modules/Payments/links";

const estimationAlertText = (
  <>
    The data on <Link to={dashboardLinks.performanceByType()}>Dashboard Summary page</Link> is an
    estimation derived from real-time events. The actual revenue paid may vary slightly.
  </>
);

const estimationNotifications: INotificationItem[] = [
  {
    id: "estimation-revenue-data",
    title: estimationAlertText,
    intent: "info",
  },
];

const paymentsNotifications: INotificationItem[] = [
  {
    id: "payments-wire-fees",
    title: "Wires may be subject to banking fees.",
    intent: "warning",
  },
  {
    id: "payments-returned-fees",
    title:
      "Any fees incurred from returned or failed payments will be the responsibility of the client. Please ensure your payment details and currency are accurate.",
    intent: "danger",
  },
  {
    id: "payments-deprecated-page",
    title: (
      <>
        <Link to={paymentsLinks.payments()}>Payment page</Link> is no longer updated as of August
        2025. For current payment information, please refer to{" "}
        <a href="https://trolley.com/" target="_blank" rel="noreferrer">
          Trolley
        </a>
        .
      </>
    ),
    intent: "danger",
  },
];

export const getHeaderNotifications = (ability: RootAbility): INotificationItem[] => {
  const items: INotificationItem[] = [...estimationNotifications];

  if (ability.canViewPayments() || ability.canViewPaymentsTrolley() || ability.canViewPaymentsTransactionHistory()) {
    items.push(...paymentsNotifications);
  }

  return items;
};
